import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Button from '@wetransfer/transfer/component/form/element/button';
import I18n from '@wetransfer/transfer/modules/i18n';
import Actions from '@wetransfer/transfer/store/action';

export function AcceptButton({
  onClick,
  acceptAll,
  context,
  cookieWallVariant,
  additionalClass,
}) {
  const handleOnClick = () => {
    acceptAll(context, cookieWallVariant);
    onClick && onClick();
  };

  let translatedText = 'transfer.consent-manager.button-accept';

  if (context !== 'intro_splash') {
    translatedText = 'transfer.consent-manager.button-accept-all';
  }

  const classes = classnames('welcome__button welcome__button--accept', {
    [additionalClass]: additionalClass,
  });

  return (
    <Button
      text={I18n.t(translatedText)}
      className={classes}
      onClick={handleOnClick}
    />
  );
}

AcceptButton.propTypes = {
  onClick: PropTypes.func,
  acceptAll: PropTypes.func.isRequired,
  context: PropTypes.string.isRequired,
  cookieWallVariant: PropTypes.string.isRequired,
  additionalClass: PropTypes.string,
};

export const mapDispatchToProps = (dispatch) => ({
  acceptAll: (context, cookieWallVariant) => {
    dispatch(Actions.Consent.acceptAll(context, cookieWallVariant));
    dispatch(Actions.Session.acceptTrackers());
  },
});

export default connect(null, mapDispatchToProps)(AcceptButton);
